<template>
  <!-- <basic-container > -->
  <div class="card-container" style="background: #fff">
    <el-button-group>
      <el-button
        :class="healthButton == 2 ? 'healthButton healthActive' : 'healthButton'"
        @click="click(2)"
        >数据统计</el-button
      >
      <el-button
        :class="healthButton == 1 ? 'healthButton healthActive' : 'healthButton'"
        @click="click(1)"
        >数据报表</el-button
      >
    </el-button-group>

    <div v-if="healthButton === 1" style="padding:10px !important; background-color: #FFF;">
      <avue-crud
        :option="option"
        :data="data"
        ref="crud"
        v-model="form"
        :page.sync="page"
        @refresh-change="refreshChange"
        :header-cell-class-name="headerCellClassName"
      >
        <!-- @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @on-load="onLoad" -->

        <template slot="menuLeft"> </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" size="small" @click="archiveType(scope.row)">
            档案信息
          </el-button>
          <!-- <el-button type="text" size="small" @click="datashow(scope.row)">
          动态数据展示
        </el-button> -->
          <el-button type="text" size="small" @click="datashow(scope.row)">
            动态数据达标
          </el-button>
        </template>
      </avue-crud>
    </div>

    <div v-if="healthButton === 2" class="dashboard-container">
      <div class="cards-wrapper">
        <div class="card-container">
          <div
            v-for="(item, index) in option1.data"
            :key="'opt1-' + index"
            class="custom-card"
            :style="{ borderTop: `3px solid ${getCardColor(index)}` }"
            @click="toPage(index)"
          >
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img
                v-if="index === 0"
                src="@/page/login/images/0001.png"
                class="count-icon"
                alt="icon"
              />
              <img
                v-if="index === 1"
                src="@/page/login/images/0002.png"
                class="count-icon"
                alt="icon"
              />
              <img
                v-if="index === 2"
                src="@/page/login/images/0003.png"
                class="count-icon"
                alt="icon"
              />
              {{ item.count }}
            </p>
          </div>
        </div>

        <div class="card-container">
          <div
            v-for="(item, index) in option2.data"
            :key="'opt2-' + index"
            class="custom-card"
            :style="{ borderTop: `3px solid ${getCardColor(index)}` }"
            @click="toPage(index + 3)"
          >
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img
                v-if="index === 0"
                src="@/page/login/images/0004.png"
                class="count-icon"
                alt="icon"
              />
              <img
                v-if="index === 1"
                src="@/page/login/images/0005.png"
                class="count-icon"
                alt="icon"
              />
              <img
                v-if="index === 2"
                src="@/page/login/images/0006.png"
                class="count-icon"
                alt="icon"
              />
              {{ item.count }}
            </p>
          </div>
        </div>

        <div class="card-container">
          <div
            v-for="(item, index) in option3.data"
            :key="'opt3-' + index"
            class="custom-card"
            :style="{ borderTop: `3px solid ${getCardColor(index)}` }"
            @click="toPage(index + 6)"
          >
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img
                v-if="index === 0"
                src="@/page/login/images/0007.png"
                class="count-icon"
                alt="icon"
              />
              <img
                v-if="index === 1"
                src="@/page/login/images/0008.png"
                class="count-icon"
                alt="icon"
              />
              <img
                v-if="index === 2"
                src="@/page/login/images/0009.png"
                class="count-icon"
                alt="icon"
              />
              {{ item.count }}
            </p>
          </div>
        </div>

        <div class="card-container">
          <div
            v-for="(item, index) in option4.data"
            :key="'opt4-' + index"
            class="custom-card"
            :style="{ borderTop: `3px solid ${getCardColor(index)}` }"
            @click="toPage(index + 9)"
          >
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img
                v-if="index === 0"
                src="@/page/login/images/0010.png"
                class="count-icon"
                alt="icon"
              />
              <img
                v-if="index === 1"
                src="@/page/login/images/0011.png"
                class="count-icon"
                alt="icon"
              />
              <img
                v-if="index === 2"
                src="@/page/login/images/0012.png"
                class="count-icon"
                alt="icon"
              />
              {{ item.count }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </basic-container> -->
</template>

<script>
import { getOnlineManageDataCenter } from "@/api/health/manage";

export default {
  name: "ThreeCardLayout",
  data() {
    return {
      channel: window.localStorage.getItem("channel"),
      healthButton: 2,
      isSelected: 1,
      list: [
        { b: 0, c: 0 },
        // { b: 0, c: 3 },
        // { b: 0, c: 4 },
        // { b: 0, c: 6 },
        // { b: 0, c: 10 },
        // { b: 0, c: 0 },
        // { b: 0, c: 0 },
        // { b: 4, c: 35 },
        // { b: 19, c: 43 },
        // { b: 9, c: 32 },
        // { b: 19, c: 20 },
        // { b: 15, c: 17 },
        // { b: 0, c: 0 },
        // { b: 0, c: 0 },
        // { b: 18, c: 12 },
        // { b: 7, c: 15 },
        // { b: 8, c: 2 },
        // { b: 4, c: 5 },
      ],
      date1: [],
      headerCellClassName: 'headerClass',
      option: {
        indexLabel: "序号",
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        selection: true,
        column: [
          {
            label: "设备开通率",
            prop: "name",
            // search: true
          },
          {
            label: "使用时长",
            prop: "mobile",
            // search: true
          },
          {
            label: "达标率",
            prop: "mobile",
            // search: true
          },
          {
            label: " 患者佩戴数据",
            type: "select",
            // search: true
          },
          {
            label: "报警事件统计",
            prop: "mobile",
            // search: true
          },
        ],
      },
      option1: {
        data: [
          {
            title: "服务总人数",
            count: 0,
            note: "人",
          },
          {
            title: "服务总人次",
            count: 0,
            note: "人次",
          },
          {
            title: "健康档案未完成用户",
            count: 0,
            note: "人",
          },
        ],
      },
      option2: {
        data: [
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "健康数据未更新用户",
            count: 0,
            note: "人次",
          },
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "周状态周报未查看用户",
            count: 0,
            note: "个",
          },
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "健康方案未生成用户",
            count: 0,
            note: "个",
          },
        ],
      },
      option3: {
        data: [
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "行为干预未完成用户 (周六更新)",
            count: 0,
            note: "个",
          },
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "高风险用户",
            count: 0,
            note: "人次",
          },
          {
            click: function (item) {
              alert("开发中");
            },
            title: "AI咨询使用用户人数及频率",
            count: 0,
            note: "人",
          },
        ],
      },
      option4: {
        data: [
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "昨日电量高于30%用户统计(连续三日皆高于红字显示)",
            count: 0,
            note: "个",
          },
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "三天建模未完成客户统计",
            count: 0,
            note: "人次",
          },
          {
            click: function (item) {
              alert("开发中");
            },
            title: "会员人数统计",
            count: 0,
            note: "人次",
          },
        ],
      },
      params: {
        channel: window.localStorage.getItem("channel"),
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      data: [],
      form: {}
    };
  },
  created() {},
  mounted() {
    this.onload();
  },
  beforeRouteLeave(to, from, next) {
    const state = {
      params: { ...this.params },
      page: { ...this.page },
    };
    sessionStorage.setItem("onlineManager", JSON.stringify(state));
    next();
  },
  methods: {
    onload() {
      getOnlineManageDataCenter(this.params).then((res) => {
        this.option1.data[0].count = res.data.serviceUerJk;
        this.option1.data[2].count = res.data.notHealthReportAndQuestion;
        this.option2.data[0].count = res.data.notDataTotal;
        this.option2.data[1].count = res.data.notWeekReportTotal;
        this.option2.data[2].count = res.data.notHealthScheme;
        this.option3.data[0].count = res.data.notBehavioralIntervention;
      });
    },

    toPage(index) {
      console.log(index);
      let url = "";
      switch (index) {
        case 0:
          url = "/healthmanagement/onlinehealthmanagement";
          break;
        case 2:
          this.params.notHealthReportAndQuestion = 1;
          url = "/healthmanagement/onlinehealthmanagement";
          break;
        case 3:
          this.params.notData = 1;
          url = "/healthmanagement/onlinehealthmanagement";
          break;
        case 4:
          this.params.notWeekReport = 1;
          url = "/healthmanagement/onlinehealthmanagement";
          break;
        case 5:
          this.params.notHealthScheme = 1;
          url = "/healthmanagement/onlinehealthmanagement";
          break;
        case 6:
          this.params.notBehavioralIntervention = 1;
          url = "/healthmanagement/onlinehealthmanagement";
          break;
      }
      this.$router.push({
        path: url,
      });
    },

    // 动态获取卡片颜色（按顺序循环）
    getCardColor(index) {
      const colors = [
        "rgb(255, 255, 255)",
        "rgb(255, 255, 255)",
        "rgb(255, 255, 255)",
      ];
      return colors[index % colors.length];
    },

    click(index) {
      this.healthButton = index;
    },

    // avue
    searchReset() {
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      params.vipLevel = 2;
      params.channel = window.localStorage.getItem("channel");
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },
  },
};
</script>

<style scoped>
.card-container {
  width: 100%;
  max-width: 100vw; /* 可根据需要调整最大宽度 */
  margin: 0 auto;
  padding: 1vw;
  box-sizing: border-box;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vw;
  gap: 1vw;
}

.card {
  background: #fff;
  /* border-radius: 8px; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card-50 {
  flex: 1 1 calc(40% - 1vw); /* 50%宽度减去gap */
  height: 43vh;
}

.card-20 {
  flex: 1 1 calc(20% - 1vw); /* 20%宽度减去gap */
  height: 43vh;
}

.chart-buttons {
  position: absolute;
  top: 0.5vw; /* 距离顶部距离 */
  right: 1vw; /* 距离右侧距离 */
  z-index: 100; /* 确保按钮在图表上方 */
  opacity: 0.9; /* 可选：轻微透明效果 */
  width: auto;
}

.card-header {
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-total {
  font-size: 24px;
  font-weight: 600;
  margin-top: 8px;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom:2px;
}
.healthActive{
  border-bottom:3px solid #409EFF;
  color:#409EFF;
  font-weight: bold;
}
</style>

<style scoped lang="scss">
.dashboard-container {
  height: 85vh;
  display: flex;
  flex-direction: column;

  .basic-container {
    flex: 1;
    padding: 2vh 2vw; /* 使用视口单位 */
    display: flex;
    flex-direction: column;
    background: transparent; /* 确保容器背景透明 */
  }

  .cards-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0vh 0; /* 添加一些内边距 */
    gap: 5vh;
  }

  .card-container {
    display: flex;
    gap: 8vw;
    flex: 1;
    min-height: 0;
    padding: 1vh 0;
    justify-content: center;
  }

  .custom-card {
    flex: 1;
    // max-width: 300px; /* 限制卡片最大宽度 */
    min-width: 180px; /* 设置最小宽度 */
    background: #fff;
    border-radius: 4px;
    padding: 2vh 2vw; /* 使用视口单位 */
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1); // 悬停时阴影加深
    }

    h2 {
      /* 修正选择器从h3改为h2以匹配模板 */
      font-size: clamp(14px, 1.5vh, 18px); /* 使用clamp函数设置响应式字体 */
      margin-bottom: 15px;
      color: #000000;
    }

    p {
      display: flex;
      align-items: center;
      gap: 2vw; /* 使用视口单位 */
      font-size: clamp(24px, 4vh, 44px); /* 响应式字体大小 */
      font-weight: bold;
      margin: 0;
      color: #000 !important; /* 数字改为黑色，使用important覆盖内联样式 */

      &::after {
        content: attr(data-note); /* 从data-note属性获取内容 */
        font-size: clamp(14px, 2vh, 25px);
        margin-left: 1px;
        font-weight: normal;
        color: #000000;
      }
    }

    .count-icon {
      width: clamp(40px, 6vh, 80px); /* 响应式图标大小 */
      height: clamp(40px, 6vh, 80px);
      object-fit: contain;
    }
  }
}

.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
